import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.BusinessInfoFieldGroup';

export default defineMessages({
  blockHeading: {
    id: `${scope}.blockHeading`,
    defaultMessage: 'Business Information',
  },
  businessNameLabelText: {
    id: `${scope}.businessNameLabelText`,
    defaultMessage: 'Business Name',
  },
  contactNameLabelText: {
    id: `${scope}.contactNameLabelText`,
    defaultMessage: 'Contact Name',
  },
  phoneLabelText: {
    id: `${scope}.phoneLabelText`,
    defaultMessage: 'Phone',
  },
  tAndCLabelText: {
    id: `${scope}.tAndCLabelText`,
    defaultMessage: 'Terms and conditions',
  },
  emailLabelText: {
    id: `${scope}.emailLabelText`,
    defaultMessage: 'Email',
  },
  passwordLabelText: {
    id: `${scope}.passwordLabelText`,
    defaultMessage: 'Password',
  },
  websiteLabelText: {
    id: `${scope}.websiteLabelText`,
    defaultMessage: 'Website',
  },
  
  aboutUsLabelText: {
    id: `${scope}.aboutUsLabelText`,
    defaultMessage: 'About Us',
  },
  
  businessDescriptionLabelText: {
    id: `${scope}.businessDescriptionLabelText`,
    defaultMessage: 'Business Description',
  },
  
  socialsHeadingText: {
    id: `${scope}.socialsHeadingText`,
    defaultMessage: 'Social Media',
  },
  
  hoursHeadingText: {
    id: `${scope}.hoursHeadingText`,
    defaultMessage: 'Business Hours',
  },
});
